/**
 * @file: 横杆文字模式渲染
 * @author: xiaolong.huang@dmall.com
 */

import * as Toolkit from '../../../toolkit';
import * as UIToolkit from '../../../UIToolkit/index';
import * as CubeTree from '../../../cubeTree/index';
import FrontCubeData from '../../../frontCubeData/index';
import Config from '../../../config';

export function renderBeamTxtModel(cube: CubeNode): void {
    let parentCubeId: CubeId = CubeTree.findParentIdByCubeId(cube.id);
    let layerWidth: LogicsicsMeasurement = FrontCubeData.getLogicValue(cube.id, 'moduleWidth');
    let layerHeight: LogicsicsMeasurement = FrontCubeData.getLogicValue(cube.id, 'moduleHeight');
    let textEl: JQuery = cube.jView.find('.J_BeamTag');
    let txtList: Array<string> = UIToolkit.getLayerTxtList({
        cube,
        checkList: Config.getGlobalConfig('TAG_LIST'),
        tagListMap: Config.getGlobalConfig('TAG_LIST_MAP')
    });

    // 立式货架层板
    if (CubeTree.isShelf(parentCubeId) && layerWidth < 0) {
        layerWidth = FrontCubeData.getLogicValue(parentCubeId, 'width');
    }

    if (CubeTree.isSketchpad(parentCubeId) && layerWidth < 0) {
        layerWidth = layerWidth > -1 ? layerWidth : 120;
    }

    let font: LogicsicsMeasurement = Toolkit.computeFontSize({
        continerWidth: layerWidth,
        continerHeight: layerHeight,
        strLength: txtList.join('').length,
        maxFontSize: 12
    });
    let txtStr: string = txtList.join('/');

    textEl
    .css({
        fontSize: font + 'px',
        display: 'block'
    })
    .attr('title', txtStr);
    Toolkit.html(textEl, txtStr);
}
